import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerEspe'; 
import Card from './areaCard'; // aqui é o "EspecialidadesCards"

const Especialidades = () => {
  return (
    <div>
      <Header />
      <VLibras />
      <Card />
    </div>
  );
};

export default Especialidades;
